import React from 'react'
import Lang from './Lang'

const APP_VERSION = 'v. 2.01'

export default class Footer extends React.Component {
	render() {
		const year = (new Date()).getFullYear()
		return <footer >
			<div className="row">
				<div className="col-md-2">
					<Lang />
				</div>
			</div>
			<div className="row">
				<div className='col-md-12 text-center'>
					<i>
						Copyright © {year} AB S.A ({APP_VERSION})
					</i>
				</div>
			</div>
		</footer>
	}
}